import { render } from "./AdminRoleCreate.vue?vue&type=template&id=48760417&ts=true"
import script from "./AdminRoleCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRoleCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__